/* eslint-disable sort-keys */
const translations = {
  Cart: "Cart",
  colorado: "colorado",
  Colorado: "Colorado",
  Color: "Color",
  Colorful: "Colorful",
  Customize: "Customize",
  Dollar: "Dollar",
  Gray: "Gray",
  Honor: "Honor",
  Instalment: "Installment",
  JEWELRY: "JEWELRY",
  Jewelry: "Jewelry",
  Labor: "Labor",
  Mom: "Mom",
  Moms: "Moms",
  Personalization: "Personalization",
  Personalize: "Personalize",
  Personalized: "Personalized",
  Personalized_Jewelry: "Personalized Jewelry",
  Personalizing: "Personalizing",
  Shipping: "Shipping",
  Symbolize: "Symbolize",
  Vermeil: "Vermeil",
  WatchBandColor: "Watch Band Color",
  WatchCaseColor: "Watch Case Color",
  authorize: "authorize",
  business: "business",
  cart: "cart",
  center: "center",
  centralized: "centralized",
  collections: {
    Jewelry: "Jewelry",
    Personalized: "Personalized",
    Personalized_Jewelry: "Personalized Jewelry",
    Personalized_jewelry: "Personalized jewelry",
    color: "color",
    jewelry: "jewelry",
    mom: "mom",
    personalized: "personalized",
  },
  bicolor: "bicolor",
  Bicolor: "Bicolor",
  color: "color",
  colorful: "colorful",
  customization: "customization",
  Customization: "Customization",
  customize: "customize",
  customizable: "customizable",
  Customizable: "Customizable",
  dollar: "dollar",
  favorite: "favorite",
  Favorite: "Favorite",
  gray: "gray",
  honor: "honor",
  instalment: "installment",
  itemize: "itemize",
  Itemize: "Itemize",
  itemized: "itemized",
  Itemized: "Itemized",
  jeweler: "jeweler",
  jewelry: "jewelry",
  labor: "labor",
  mom: "mom",
  moms: "moms",
  mommy: "mommy",
  Mommy: "Mommy",
  neighbor: "neighbor",
  neighboring: "neighboring",
  organization: "organization",
  personalizable: "personalizable",
  personalization: "personalization",
  personalize: "personalize",
  personalized: "personalized",
  personalized_jewelry: "personalized jewelry",
  personalizing: "personalizing",
  recognized: "recognized",
  ship: "ship",
  shipping: "shipping",
  ships: "ships",
  specialize: "specialize",
  symbolize: "symbolize",
  tenK: "10K",
  tenk: "10k",
  "number.currency.name": "dollar",
  "number.currency.code": "USD",
  "number.currency.format.delimiter": ",",
  "number.currency.format.format": "%u%n",
  "number.currency.format.precision": 2,
  "number.currency.format.separator": ".",
  "number.currency.format.significant": false,
  "number.currency.format.strip_insignificant_zeros": false,
  "number.currency.format.unit": "$",
  "number.format.delimiter": ",",
  "number.format.precision": 3,
  "number.format.round_mode": "default",
  "number.format.separator": ".",
  "number.format.significant": false,
  "number.format.strip_insignificant_zeros": false,
  "number.human.decimal_units.format": "%n %u",
  "number.human.decimal_units.units.billion": "Billion",
  "number.human.decimal_units.units.million": "Million",
  "number.human.decimal_units.units.quadrillion": "Quadrillion",
  "number.human.decimal_units.units.thousand": "Thousand",
  "number.human.decimal_units.units.trillion": "Trillion",
  "number.human.decimal_units.units.unit": "",
  "number.human.format.delimiter": "",
  "number.human.format.precision": 3,
  "number.human.format.significant": true,
  "number.human.format.strip_insignificant_zeros": true,
  "number.human.storage_units.format": "%n %u",
  "number.human.storage_units.units.byte.one": "Byte",
  "number.human.storage_units.units.byte.other": "Bytes",
  "number.human.storage_units.units.eb": "EB",
  "number.human.storage_units.units.gb": "GB",
  "number.human.storage_units.units.kb": "KB",
  "number.human.storage_units.units.mb": "MB",
  "number.human.storage_units.units.pb": "PB",
  "number.human.storage_units.units.tb": "TB",
  "number.nth.ordinalized": {},
  "number.nth.ordinals": {},
  "number.percentage.format.delimiter": "",
  "number.percentage.format.format": "%n%",
  "number.precision.format.delimiter": "",
  "address.city": "City",
  "address.country": "United States",
  "address.state": "State",
  "address.zip": "ZIP Code",
  "Wish List": "Wish List",
}
export default translations
